import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/Contacts/Get`, payload),
    GetByID: (payload) => Repository.post(`/api/Contacts/GetByID`, payload),
    Add: (payload) => Repository.post(`/api/Contacts/Add`, payload),
    UpdateNote: (payload) => Repository.post(`/api/Contacts/UpdateNote`, payload),
    UpdateApproval: (payload) => Repository.post(`/api/Contacts/UpdateApproval`, payload),
}
